import _ from 'lodash';

/* @ngInject */
export default function EquipmentNotificationsService($q, $sails, $log, EquipmentInfoService) {
  const service = this;

  service.getEquipmentList = getEquipmentList;
  service.getEquipmentNotifications = getEquipmentNotifications;
  service.getLocalTimeZone = () => new Intl.DateTimeFormat().resolvedOptions().timeZone;
  service.getLogs = getLogs;
  service.updateNotePolicy = updateNotePolicy;

  function getEquipmentList() {
    return EquipmentInfoService.getAllEquipments()
      .then(equipment =>
        _.reduce(equipment, (memo, eq) => {
          const { id, name } = eq;
          memo.asArray.push({
            id,
            name
          });
          memo.asObj[id] = eq;
          return memo;
        }, {
          asObj: {},
          asArray: []
        })
      );
  }

  function getEquipmentNotifications(equipmentId) {
    return $sails.get(`/equipment/${equipmentId}`)
      .then(res => res.data);
  }

  function getLogs(equipmentId, limit, filterDate) {
    return $sails.get(`/userlog/equipment/${equipmentId}?limit=${limit}&filterDate=${filterDate}`)
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function updateNotePolicy(equipments) {
    return _.reduce(equipments, (equipmentResults, eq) => _.set(equipmentResults, eq.id, {
      // removes all else like "isOpen" and "enableEdit" from object
      eventsConfig: _.map(eq.notificationConfig.eventsConfig, (config) => {
        const { escalations } = config;
        escalations.levels = _.map(
          escalations.levels,
          lvl => _.pick(lvl, ['customMessage', 'emails', 'escalationTime', 'phoneNumbers'])
        );
        return { ..._.pick(config, ['description', 'name', 'enabled', 'title', 'schedule']), escalations };
      })
    }), {});
  }
}
